(function () {
  "use strict";

  FeaturesCtrl.$inject = ['$scope', '$rootScope', 'mtypes', '$window', '$location', 'authView', 'trackingService'];
  angular
    .module('trainerWebApp.controllers')
    .controller('FeaturesCtrl', FeaturesCtrl);

  function FeaturesCtrl($scope, $rootScope, mtypes, $window, $location, authView, trackingService) {

    $window.document.title = "Features Preview | Mindflash Training Management System";
    $rootScope.page = {name: 'features', title: "features"};

    $scope.viewState = {
      advancedFeatures: [
        {
          name: "Series",
          id: mtypes.featureEntry.series,
          badge: "icn_series.png",
          description: "Series allows trainees to take multiple courses in the sequence you specify."
        }, {
          name: "Catalogs",
          id: mtypes.featureEntry.courseCatalog,
          badge: "icn_catalog.png",
          description: "Ability to group courses or series, and save time by eliminating the need to invite trainees to courses or series."

        }, {
          name: "Advanced Reports",
          id: mtypes.featureEntry.goodDataDashboardLight,
          badge: "icn_report.png",
          description: "Visual overview dashboard of all trainees and courses, plus detail view of courses, series, quizzes and trainees."

        }, {
          name: "Duration Tracking",
          id: mtypes.featureEntry.durationTracking,
          badge: "icn_duration.png",
          description: "Track how long it takes for trainees to complete a course."

        }
      ],
      proFeatures: [
        {
          name: "Account Access Controls",
          id: mtypes.featureEntry.trainerPermissions,
          badge: "icn_control.png",
          description: "Define administrator, trainer, manager, team lead, and reporter roles that control access to account settings, billing, content and user groups."
        },
        {
          name: "SSO / API",
          id: mtypes.featureEntry.api,
          badge: "icn_sso.png",
          description: "Use the API for SSO (Active Directory, Salesforce, SAML), trainee management and reporting."
        },
        {
          name: "Sell Courses",
          id: mtypes.featureEntry.shopify,
          badge: "icn_shopify.png",
          description: "Generate revenue by selling your courses to your customers, partners or resellers."
        },
        {
          name: "Custom Branding",
          id: mtypes.featureEntry.customBranding,
          badge: "icn_color.png",
          description: "Customize Mindflash with your official brand and colors."
        },
        {
          name: "SCORM",
          id: mtypes.featureEntry.sCORM,
          badge: "icn_scorm.png",
          description: "Import SCORM content from Articulate Storyline and Adobe Captivate."
        },
        {
          name: "Languages",
          id: mtypes.featureEntry.localization,
          badge: "icn_language.png",
          description: "Trainees can take courses and receive email communications in their local language."
        }
      ],
      advancedTrialExpire: Math.max(0, authView.getAdvancedTrialDaysLeft()),
      showPro: ["Basic", "Advanced"].indexOf(authView.getTierDescription()) > -1,
      showAdvanced: authView.getTierDescription() === "Basic",
      disableUpgrade: !authView.isAdministrator()
    };

    var interest, interestValue;

    setup();

    function setup() {
      var query = $location.search();
      interestValue = null;
      interest = null;
      if (query && query.s) {
        interestValue = query.s;
        interest = (_.invert(mtypes.featureEntry))[interestValue];
      }

      trackingService.trackEvent(trackingService.pages.featurePreview.name, trackingService.pages.featurePreview.actions.interestAction);
      trackingService.trackKissMetricsEvent("Upgrade interest", {
        interest: interest,
        interestValue: interestValue
      });
    }

    $scope.upgrade = function (source) {
      if (!authView.isAdministrator()) return;

      trackingService.trackKissMetricsEvent("Upgrade button click", {
        interest: interest,
        interestValue: interestValue,
        targetTier: source
      });

      trackingService.trackEvent(trackingService.pages.featurePreview.name, trackingService.pages.featurePreview.actions.upgradeAction);
      return $location.path('/TMS/Manage_Account/Subscribe').search({});
    };

    $scope.getCellStyle = function (feature) {
      if (feature == mtypes.featureEntry.trainerPermissions)
        return {height: '100px'};
      return null;
    };
  }

})();
